module.exports = __webpack_public_path__ + "assets/2021_lockup.ba61943b.svg";